<template>
  <div v-if="!isLoading" class="account">
    <admin-layout title="Company">
      <bg-field label="Name" name="full">
        <bg-input name="name" :disabled="true" :value="company.name" />
      </bg-field>
      <bg-field label="Address" name="full">
        <bg-input name="address" :disabled="true" :value="company.address" />
      </bg-field>
      <bg-field label="City" name="city">
        <bg-input name="city" :disabled="true" :value="company.city" />
      </bg-field>
      <bg-field label="Country" name="country">
        <bg-input
          name="country"
          :disabled="true"
          :value="company.country.name"
        />
      </bg-field>
      <h2 v-bg-typography="'h1'" class="bg-empty-space__title">Contact</h2>
      <bg-field label="Primary contact" name="admin">
        <bg-input
          name="admin"
          :disabled="true"
          :value="
            company.admin.profile.first_name +
            ' ' +
            company.admin.profile.last_name
          "
        />
      </bg-field>
      <bg-field label="Primary contact email" name="admin_email">
        <bg-input
          name="admin_email"
          :disabled="true"
          :value="company.admin.email"
        />
      </bg-field>
      <bg-field label="Account manager" name="business_developer">
        <bg-input
          name="business_developer"
          :disabled="true"
          :value="
            company.business_developer.profile.first_name +
            ' ' +
            company.business_developer.profile.last_name
          "
        />
      </bg-field>
      <bg-field label="Account manager email" name="business_developer_email">
        <bg-input
          name="business_developer_email"
          :disabled="true"
          :value="company.business_developer.email"
        />
      </bg-field>
      <bg-field label="Consultant" name="consultant">
        <bg-input
          name="consultant"
          :disabled="true"
          :value="
            company.consultant.profile.first_name +
            ' ' +
            company.consultant.profile.last_name
          "
        />
      </bg-field>
      <bg-field label="Consultant email" name="consultant_email">
        <bg-input
          name="consultant_email"
          :disabled="true"
          :value="company.consultant.email"
        />
      </bg-field>
    </admin-layout>
    <admin-layout title="Contract">
      <bg-field label="Start date" name="start_date">
        <bg-input name="start_date" :disabled="true" :value="startDate" />
      </bg-field>
      <bg-field label="End date" name="end_date">
        <bg-input name="end_date" :disabled="true" :value="endDate" />
      </bg-field>
      <bg-field label="Available Professional tests" name="proessional_tests">
        <bg-input
          name="proessional_tests"
          :disabled="true"
          :value="contract.available_tests.professional"
        />
      </bg-field>
      <bg-field label="Available Essential tests" name="essential_tests">
        <bg-input
          name="essential_tests"
          :disabled="true"
          :value="contract.available_tests.essential"
        />
      </bg-field>
    </admin-layout>
  </div>
</template>

<style scoped>
.account {
  display: flex;
  justify-content: space-between;
}
.display {
  display: none;
}
</style>

<script>
import AdminLayout from "@/layouts/admin";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgTypography from "@/directives/bg-typography";
import API from "@/api";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "organization",
  directives: {
    BgTypography,
  },
  components: {
    AdminLayout,
    BgField,
    BgInput,
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  data() {
    return {
      isPasswordChanging: false,
      company: {},
      isLoading: true,
      contract: {},
      startDate: "",
      endDate: "",
    };
  },
  mounted() {
    API.user.getCompany(this.userState.user.company.id).then((res) => {
      this.company = res;
      const currentContract = res.contracts.find((i) => i.is_active);
      this.contract = currentContract;
      this.startDate = moment(currentContract.start_date).format("DD-MM-YY");
      this.endDate = moment(currentContract.end_date).format("DD-MM-YY");
      this.isLoading = false;
    });
  },
  methods: {},
};
</script>
